import { when } from 'ramda';

export const parseInvoiceNumber = (value = '') => {
	const isWithDots = (val) => val.includes('.');
	const parseWithDots = (val) => val.split('.')[1];

	return when(isWithDots, parseWithDots)(value);
};
